/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Location} from '@angular/common';
import {AfterViewInit, ChangeDetectionStrategy, Component, OnInit, Optional} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NbWindowRef} from '@nebular/theme';
import {Channel, FileService, Role} from 'compob2b-libs';
import {map, tap} from 'rxjs/operators';
import {translations} from '../../../../../environments/translations.ru';
import {CreateUpdateComponent} from '../../../../admin-shared/crud-components/create-update/create-update.component';
import {RelatedEntity} from '../../../../admin-shared/interfaces/related.entity';
import {FormConfigService} from '../../../../admin-shared/services/form-config.service';
import {CATALOG_FORM} from '../catalog-forms.config';
import {CatalogService} from '../catalog.service';
import {AuthService} from 'compob2b-auth';

@Component({
  selector: 'app-catalog-create',
  templateUrl: './create-update-catalog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateUpdateCatalogComponent extends CreateUpdateComponent<any> implements OnInit, AfterViewInit {

  title = translations.catalog;
  catalogTreeSynonymUpdateTitle = translations.catalogTreeSynonymUpdate;
  protected uri = '/catalog/rapid';
  absolutePath = '/cabinet/pim/catalog';
  catalogTreeSynonym = false;
  protected allRoles: Role[];

  constructor(
    protected readonly catalogService: CatalogService,
    protected readonly formConfigService: FormConfigService,
    protected readonly route: ActivatedRoute,
    protected readonly location: Location,
    @Optional() protected readonly windowRef: NbWindowRef,
    protected readonly fileService: FileService,
    protected readonly authService: AuthService
  ) {
    super(formConfigService, route, location, windowRef, fileService);
  }

  ngOnInit() {
    if (this.environment.accessRolesCatalog) {
      this.uri = this.catalogService.apiUrl + '/rapid';
    }
    this.id = this.route.snapshot.paramMap.get('id');
    const catalogs = this.catalogService.getLazyCatalogTree().pipe(
      map(catalogList => catalogList.filter(catalog => parseInt(this.id, 10) !== catalog.id))
    );
    const channels = this.compoApiService.get<Channel[]>(this.uri + '/channels-list').pipe(map(response => response.data));

    let relatedEntities: RelatedEntity[] =
      [{multipleEntity: catalogs, multipleField: 'parentId'},
        {multipleEntity: channels, multipleField: 'channelIDs'}
      ];

    this.config = {
      uri: this.uri,
      columns: CATALOG_FORM,
      title: this.title,
      absolutePath: this.absolutePath,
      relatedEntity: relatedEntities
    };

    super.setConfig(this.config);

    if (this.environment.accessRolesCatalog) {
      const roles = this.compoApiService.get<Role[]>(this.catalogService.apiUrl + '/list-roles')
        .pipe(map(response => response.data), tap(data => this.allRoles = data));
      relatedEntities.push({multipleEntity: roles, multipleField: 'roles'});
    }

    this.initRoles();
    super.setConfig(this.config);
    super.ngOnInit();
    this.initParentCatalog();

    this.model.editMode = this.editMode;
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.cdr.detectChanges();
  }

  /**
   * we need to initialize parentId property
   * even when we are creating a new record (creating mode)
   */
  private initParentCatalog(): void {
    const parent = this.route.snapshot.paramMap.get('parent');
    this.model = {id: null, header: null, parentId: null};

    if (!this.editMode) {
      this.model.parentId = 1;
    }

    if (parent !== null) {
      this.model.parentId = Number(parent);
    }
  }

  afterSetModel(): void {
    this.editName = this.model.header;
    if (this.environment.accessRolesCatalog && this.model.roles) {
      this.model.roles = this.model.roles.map((role: Role) => role.id);
    }
  }

  beforeSubmit(): void {
    super.beforeSubmit();

    this.entity.termIDs = 'terms' in this.model && Array.isArray(this.model.terms) ? this.model.terms.map(term => term.id) : [];
    this.entity.catalogTreeSynonym = this.catalogTreeSynonym;

    if (this.environment.accessRolesCatalog) {
      this.entity.roles = this.model.roles === null ? [] : this.allRoles.filter(role => this.model.roles.includes(role.id));
    }

    this.config.columns.forEach(item => {
      if (item.key === 'roles') {
        console.log(item)
      }
    });
    console.log(this.model);
  }

  changeCatalogTreeSynonym() {
    this.catalogTreeSynonym = !this.catalogTreeSynonym;
  }

  private initRoles(): void {
    if (this.environment.accessRolesCatalog) {
      const manager = JSON.parse(localStorage.getItem('user'));
      this.config.columns.forEach(item => {
        if (item.key === 'roles') {
          item.templateOptions.disabled = !this.authService.isSuperAdmin();
          item.defaultValue = manager.roles.map(role => role.id);
        }
      });
    }
  }
}
